import { render, staticRenderFns } from "./rkpd_final.vue?vue&type=template&id=513ab9fc&"
import script from "./rkpd_final.vue?vue&type=script&lang=js&"
export * from "./rkpd_final.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports